// Shared CRM constants + helpers used across CRM child components.
export const AUDIT_TYPES = ["Unknown", "Verification", "Certification"];
export const SUB_STATUSES_QUALIFY = ["", "Ready to proceed", "Moderate gaps", "Material gaps — on hold", "Disqualified — structural"];
export const AU_STATES = ["NSW", "VIC", "QLD", "WA", "SA", "TAS", "ACT", "NT"];

// Lead ↔ Client split
export const LEAD_KIND = "lead";
export const CLIENT_KIND = "client";
export const CLIENT_TERMINAL_STAGES = new Set(["certified", "churned"]);
export const LEAD_TERMINAL_STAGES = new Set(["lost"]);

const MS_PER_DAY = 86_400_000;
export function daysSince(iso) {
  if (!iso) return 0;
  return Math.max(0, Math.floor((Date.now() - new Date(iso).getTime()) / MS_PER_DAY));
}

// Colour palette for the six client-pipeline stages (badges/pills).
export function clientStageBadgeClass(stageKey) {
  switch (stageKey) {
    case "onboarding": return "bg-slate-100 text-slate-700";
    case "assessment_in_progress": return "bg-[#E6F4F1] text-[#1A7F6E]";
    case "documents_in_progress": return "bg-amber-100 text-amber-800";
    case "audit_ready": return "bg-[#0D1B2A] text-white";
    case "certified": return "bg-emerald-100 text-emerald-800";
    case "churned": return "bg-rose-100 text-rose-700";
    default: return "bg-slate-100 text-slate-600";
  }
}
